import React from 'react';
import {
  DatabaseOutlined,
  PieChartOutlined,
  UserOutlined,
  LogoutOutlined,
  FundProjectionScreenOutlined,
  TeamOutlined
} from '@ant-design/icons'
import { MenuProps } from 'antd';
import { MenuItem } from '../@types/navigation';
import { handlelogout } from '../actions/authActions';

export const sideItems: MenuItem[] = [
  {
    key: 'dashboard',
    label: 'Tableau de bord',
    title: 'Tableau de bord',
    icon: React.createElement(PieChartOutlined)
  },
  {
    key: 'pricing-settings',
    label: 'Paramétrage tarifaire',
    title: 'Paramétrage tarifaire',
    icon: React.createElement(DatabaseOutlined),
    children: [
      {
        key: 'data-controller',
        label: 'Contrôleur des données',
        title: 'Contrôleur des données'
      },
      {
        key: 'repositories',
        label: 'Gestion des référentiels',
        title: 'Gestion des référentiels'
      },
      {
        key: 'pricing-config',
        label: 'Configuration tarifaire',
        title: 'Configuration tarifaire'
      },
      {
        key: 'aiguillage-tarifaire',
        label: 'Aiguillage tarifaire',
        title: 'Aiguillage tarifaire'
      }
    ]
  },
  {
    key: 'administration',
    label: 'Administration',
    title: 'Administration',
    icon: React.createElement(TeamOutlined),
    children: [
      {
        key: 'administration/users',
        label: 'Utilisateurs',
        title: 'Utilisateurs'
      },
      {
        key: 'administration/roles',
        label: 'Rôles',
        title: 'Rôles'
      },
      {
        key: 'administration/permissions',
        label: 'Permissions',
        title: 'Permissions'
      },
      {
        key: 'audit',
        label: 'Audit trail',
        title: 'Audit trail'
      },
    ]
  },
  {
    key: 'simulations',
    label: 'Etudes et simulations',
    title: 'Etudes et simulations',
    icon: React.createElement(FundProjectionScreenOutlined),
    children: [
      {
        key: 'simulations/input',
        label: 'Simulation tarifaire',
        title: 'Simulation tarifaire'
      },
      {
        key: 'simulations/results',
        label: 'Résultats',
        title: 'Résultats'
      }
    ]
  }
]

export const items: MenuProps['items'] = [
  {
    key: '1',
    label: "My Profile",
    title: 'My Profile',
    disabled: true,
    icon: React.createElement(UserOutlined)
  },
  {
    key: '2',
    label: "Logout",
    title: 'Logout',
    icon: React.createElement(LogoutOutlined),
    onClick: () => {
      handlelogout()
        .then(() => { })
        .catch(() => { })
    }
  }
]

export const findParentKey = (childKey: any, items: MenuItem[] = sideItems): any => {
  for (const item of items) {
    if (item?.key === childKey) {
      return undefined; // If the key is a top-level item, it has no parent
    }

    // Check if item has children before accessing them
    if (item && 'children' in item && item?.children) {
      // Check if any of the children match the child key
      const isChild = item?.children.find(child => child && child.key === childKey);
      if (isChild) {
        return item?.key; // Return the parent key if a child is found
      }
      
      // Recursive search in nested children
      const parentKey = findParentKey(childKey, item.children);
      if (parentKey) {
        return parentKey;
      }
    }
  }
  return undefined; // Return undefined if no parent key is found
};

